import React, { PropsWithChildren } from 'react';
import theme from './Cards.module.scss';
import { classnames } from '@/utils/html';

interface CardRowProps extends PropsWithChildren {
    className?: string;
    bordered?: boolean;
}

const CardRow: React.FC<CardRowProps> = ({ children, className, bordered = false }) => {
    return <div className={classnames(theme.row, className, { [theme.bordered]: bordered })}>{children}</div>;
};

export default CardRow;
